import { NgModule } from "@angular/core";
import { CoreContentModule } from "@obg/ngx.core.content";

import { AccountCreatedComponent } from "./account-created.component";

const DIRECTIVES = [AccountCreatedComponent];

@NgModule({
	imports: [CoreContentModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class AccountCreatedUiModule {}
